import React, { useMemo } from 'react';
import { GENDERS } from 'configs/localData';
import { ChildrenItem as ChildrenItemProps } from 'types/contacts';

interface Props {
  child?: ChildrenItemProps;
}

const ChildrenItem = ({ child }: Props) => {
  const genderItem = useMemo(
    () =>
      GENDERS.find((gender) => gender.value === child.gender?.toLowerCase()),
    [child.gender],
  );
  return (
    <div className="children-item">
      {genderItem?.icon && (
        <genderItem.icon
          className="children-item__gender"
          style={{
            color: genderItem.color,
            backgroundColor: genderItem.background,
          }}
        />
      )}

      <span className="children-item__name text-black-base">
        {`${child.firstName || ''} ${child.lastName || ''}`}
      </span>
    </div>
  );
};

export default ChildrenItem;
